import React, { useState, useRef, useEffect } from 'react';
import { ModalBody, Modal, Row, Col, Input, Button } from 'reactstrap';
import { Edit, Delete, Money, BookmarkBorderSharp } from '@mui/icons-material';
import { db } from 'MY_LOGIN_AND_SIGNUP/db/config';

import NotificationAlert from 'react-notification-alert';

import { IconButton } from '@mui/material';
import KeyboardArrowLeftSharpIcon from '@mui/icons-material/KeyboardArrowLeftSharp';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';

import Book_Edit_Step1 from './Book_Add_Step/Book_Edit_Step1';
import Book_Delete_Step1 from './Book_Add_Step/Book_Delete_Step1';
import SelectedBatchDelete from 'components/Batch/SelectedBatchDelete';
import { algoliaAppID, algoliaSearchID } from '../Utilities/algoliaKeys';
import algoliasearch from 'algoliasearch/lite';
import SearchIcon from '@mui/icons-material/Search';
import firebase from 'firebase';

function Book_List({ setVisible, setProgressVisible, setProgressValue }) {
  const [editVisible, setEditVisible] = useState(false);
  const [bookData, setBoookData] = useState([]);
  const [editBook, setEditBook] = useState();
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);

  const [startIndex, setStartIndex] = useState(1);
  const [endIndex, setEndIndex] = useState(0);

  const [loading, setLoading] = useState(false);

  const [limit, setLimit] = useState(10);
  const [allChecked, setAllChecked] = useState(false);
  const [isAllDeleteModalVisible, setIsAllDeleteModalVisible] = useState(false);
  const [selected, setSelected] = useState(false);
  const [selectedArr, setSelectedArr] = useState([]);
  const [bookSearchValue, setBookSearchValue] = useState('');
  const searchClient = algoliasearch(algoliaAppID, algoliaSearchID);
  const bookSearchIndex = searchClient.initIndex('Book_Search');
  const [search, setSearch] = useState(false);
    const [currentUser, setCurrentUser] = useState();
    const [selectedTeacher, setSelectedTeacher] = useState({});
    const [teacherList, setTeacherList] = useState([]);

  const [lastVisibleDoc, setLastVisibleDoc] = useState(null);
  const [firstVisibleDoc, setFirstVisibleDoc] = useState(null);
  const [isNextBook, setIsNextBook] = useState(false);
  const [isPrevBook, setIsPrevBook] = useState(false);
  const notifi = useRef();

  const notify = (msg, err) => {
    let color = err == false ? 'success' : 'danger';
    let options = {
      type: color,
      place: 'tr',
      message: (
        <div>
          <div>
            <b>{err == false ? 'Success' : 'Error'}</b> - {msg}.
          </div>
        </div>
      ),
      icon: 'tim-icons icon-bell-55',
      autoDismiss: 6,
    };
    if (notifi.current) {
      notifi.current.notificationAlert(options);
    }
    // notification(options);
  };

  const getBookData = (direction = 'initial') => {
    try {
      document.querySelector('#loading-indicator').style.display = 'flex';
      setLoading(true);

      let query = db.collection('zSystemStore')
        .where('type', '==', 'book')
        .orderBy('createdAt', 'desc')
        .limit(limit + 1); // Fetch limit + 1 to check for more data

      if (currentUser?.isTeacher) {
        query = query.where('createdBy', '==', currentUser.createdBy);
      } else if (selectedTeacher.id) {
        query = query.where('createdBy', '==', selectedTeacher.id);
      }

      // Adjust query for next and previous directions
      if (direction === 'next' && lastVisibleDoc) {
        query = query.startAfter(lastVisibleDoc);
      } else if (direction === 'prev' && firstVisibleDoc) {
        query = query.endBefore(firstVisibleDoc);
      }

      query.get().then((querySnapshot) => {
        const docs = querySnapshot.docs;

        if (docs.length === 0) {
          // No documents found, reset pagination state
          setIsPrevBook(false);
          console.log('set false isNext 1');
          setIsNextBook(false);
          setBoookData([]);
          setProgressVisible(false);
          document.querySelector('#loading-indicator').style.display = 'none';
          setLoading(false);
          return;
        }
        if (direction === 'prev' && firstVisibleDoc && !docs.find(doc => doc.id === firstVisibleDoc.id)) {
          docs.push(firstVisibleDoc)
        }
        let data = docs.map(doc => doc.data()).map(item => ({ ...item, select: false }));

        // Update for previous pagination
        setIsPrevBook(direction !== 'initial' && docs.length > 0);
        
        // Check if there are more documents for next pagination
        console.log('set false isNext 2', docs.length, limit);
        if (docs.length > limit || direction === 'prev' ) {
          setIsNextBook(true);
          data.pop(); // Remove the extra item fetched
        } else {
          setIsNextBook(false);
        }
        console.log(docs, 'checking docs', docs[data.length - 1]?.id, docs[0]?.id);
        setFirstVisibleDoc(docs[0]); // First document for backward navigation
        
        setLastVisibleDoc(docs[data.length - 1]); // Last document for forward navigation

        // Calculate start and end indices
        let newStartIndex = 1;
        if (direction === 'next' && endIndex) {
          newStartIndex = endIndex + 1;
        } else if (direction === 'prev' && startIndex > limit) {
          newStartIndex = startIndex - limit;
        }

        // Handle edge case for start index
        if (newStartIndex <= 1) {
          setIsPrevBook(false);
          newStartIndex = 1;
        }

        setStartIndex(newStartIndex);
        setEndIndex(newStartIndex + data.length - 1);
        setBoookData(data);

        setProgressVisible(false);
        document.querySelector('#loading-indicator').style.display = 'none';
        setLoading(false);
      });
    } catch (error) {
      console.log(error, "Error in fetching book data");
      document.querySelector('#loading-indicator').style.display = 'none';
      setLoading(false);
    }
  };


  const getCurrentUser = () => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        db.collection('zSystemUsers')
          .doc(user.uid)
          .get()
          .then((query) => {
            let data = query.data();
            if (data.isTeacher) {
              setSelectedTeacher({ id: data._uniqueID, batchIds: data.isBatchManage, name: data.firstname + " " + data.lastname })
            }
            setCurrentUser({ isTeacher: data.isTeacher || false, createdBy: data._uniqueID, creatorName: data.firstname + " " + data.lastname });
          });
      }
    });
  };

  const getTeacher = async () => {
    try {
      const userSnapshot = await db.collection('zSystemUsers')
        .where('isTeacher', '==', true)
        .where('status', '==', 0)
        .get();

      let teacher = userSnapshot.docs.map(doc => ({ id: doc.id, batchIds: doc.data().isBatchManage, name: doc.data().firstname + " " + doc.data().lastname }));
      // if(teacher)
      setTeacherList(teacher);
    } catch (error) {
      console.log(error);
    }
  }


  useEffect(() => {
    getCurrentUser();
    getTeacher()
    setProgressValue(99);
  }, []);
  
  useEffect(()=>{
    console.log(currentUser, selectedTeacher,"selectedTeacherselectedTeacher");
    if (currentUser) getBookData();

    // if (currentUser?.isTeacher && currentUser?.createdBy ){
    //   getBookData();
    // }

    // if((currentUser?.isTeacher == false) && selectedTeacher.id){
    //   getBookData();
    // }
  },[currentUser,selectedTeacher])

  const nextSet = () => {
    // console.log('next bookData[2].title', bookData[2].createdAt)
    // if (bookData.length === limit) {
    // setClicked(true)
    if (bookData.length === 0) {
      notify('End Of the list', true);

      return;
    }
    document.querySelector('#loading-indicator').style.display = 'flex';

    db.collection('zSystemStore')
      .where('type', '==', 'book')
      .orderBy('createdAt', 'desc')
      .startAfter(bookData[bookData.length - 1].createdAt)
      .limit(limit)
      .get()
      .then((querySnapshot) => {
        let data = querySnapshot.docs.map((doc) => {
          return doc.data();
        });
        if (data.length !== 0) {
          // console.log("should go", data[2].title)
          document.querySelector('#loading-indicator').style.display = 'none';

          setBoookData(data);
          setStartIndex(endIndex + 1);
          setEndIndex((prev) => prev + data.length);
          // console.log('my user data is ', data)
        } else {
          document.querySelector('#loading-indicator').style.display = 'none';

          notify('End Of the list', true);
        }
      })
      .catch((err) => {
        document.querySelector('#loading-indicator').style.display = 'none';
        notify(err.toString(), true);
      });
    // } else {
    //   notify('End Of the list', true)
    // }
  };

  const prevSet = () => {
    document.querySelector('#loading-indicator').style.display = 'flex';

    db.collection('zSystemStore')
      .where('type', '==', 'book')
      .orderBy('createdAt')
      .startAfter(bookData[0].createdAt)
      .limit(limit)
      .get()
      .then((querySnapshot) => {
        let data = querySnapshot.docs.map((doc) => {
          return doc.data();
        });
        if (data.length !== 0) {
          document.querySelector('#loading-indicator').style.display = 'none';

          data = data.reverse();

          setStartIndex((prev) => prev - data.length - 1);
          setEndIndex((prev) => prev - bookData.length);
          setBoookData(data);
        } else {
          document.querySelector('#loading-indicator').style.display = 'none';
        }
      })
      .catch((err) => {
        document.querySelector('#loading-indicator').style.display = 'none';
        notify(err.toString(), true);
      });
  };

  const deleteSelected = () => {
    let selectedId = [];
    bookData.map((item) => {
      if (item.select && item.itemID != undefined) {
        selectedId.push(item.itemID);
      }
    });

    let batch = db.batch();
    for (let i = 0; i < selectedId.length; i++) {
      batch.delete(db.collection('zSystemStore').doc(selectedId[i]));
    }

    batch
      .commit()
      .then(() => {
        setBoookData((prev) =>
          prev.filter((item) => !selectedId.includes(item.itemID))
        );
        setIsAllDeleteModalVisible(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const bookSearch = () => {
    if (bookSearchValue == '') {
      notify('Search field can not be empty', true);
    } else {
      setSearch(true);
      document.querySelector('#loading-indicator').style.display = 'flex';

      bookSearchIndex
        .search(bookSearchValue, { typoTolerance: false })
        .then((result) => {
          if (!result?.hits?.length) {
            document.querySelector('#loading-indicator').style.display = 'none';
            setBoookData([]);
            notify('No results found', true);
          } else {
            document.querySelector('#loading-indicator').style.display = 'none';
            let filterData =[];
            if(currentUser?.isTeacher){
              filterData = result?.hits?.filter((data)=>{
                return (data.isTeacher == currentUser?.isTeacher) && (data.createdBy == currentUser?.createdBy )
              })
            } else if (currentUser?.isTeacher == false) {
              if(selectedTeacher.id){
                filterData = result?.hits?.filter((data) => {
                  return (data.createdBy == selectedTeacher.id)
                })
              }else{
                filterData = result?.hits
              }
            }
            setBoookData(filterData);
            // setReload(true);
          }
        })
        .catch((err) => {
          if (document.querySelector('#loading-indicator') !== null)
            document.querySelector('#loading-indicator').style.display = 'none';
          notify(err.toString(), true);
        });
    }
  };

  const emptyCall = () => {
    getBookData();

    setSearch(false);
  };

  return (
    <Col>
      <Row>
        {/* <div className="content" style={{ width: '100%' }}> */}
        <div className='react-notification-alert-container'>
          <NotificationAlert ref={notifi} />
        </div>
        {editVisible === true && (
          <Book_Edit_Step1
            setBoookData={setBoookData}
            booknotify={notify}
            editBook={editBook !== undefined && editBook}
            setVisible={setVisible}
            onClick={() => {
              setEditVisible(false);
            }}
          />
        )}

        {editVisible === false && (
          <>
            <Row
              style={{
                justifyContent: 'flex-start',
                width: '50%',
                paddingBottom: '8px',
              }}
            >
              
              <Col
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems:'center',
                  marginLeft: 15,
                }}
                sm={1}
              >
                {bookData !== undefined && editVisible === false && bookData?.length>0 &&(
                  <input
                    type='checkbox'
                    style={{ height: 20, width: 20 }}
                    checked={allChecked}
                    onChange={(e) => {
                      let checked = e.target.checked;
                      if (checked == true) {
                        setSelected(true);
                        setSelectedArr(bookData.map(book => { return { id: book.itemID }}));
                      } else {
                        setSelected(false);
                        setSelectedArr([]);
                      }
                      let checkedData = bookData.map((data) => {
                        data.select = checked;
                        return data;
                      });
                      setAllChecked(checked);
                      setBoookData(checkedData);
                    }}
                  />
                )}
              </Col>

              <Col sm={9}>
              <div style={{display:'flex'}}>
          {!currentUser?.isTeacher &&
                <select
                  id="teacher"
                  className="form-control"
                  value={selectedTeacher?.id || ""}
                  onChange={(e) => {
                    if (e.target.value != "") {
                      const currentTeacher = teacherList.find(teacher => teacher.id.toString() === e.target.value);
                      setSelectedTeacher(currentTeacher);
                    } else {
                      setSelectedTeacher([])
                    }
                  }}
                  style={{
                    maxWidth: '200px',
                    border: '1px solid rgb(42.67, 52.71, 82.83)',
                    borderRadius: '4px',
                    padding: '5px 10px',
                    marginRight:'10px',
                    marginBottom:'10px'
                  }}
                >
                  <option value="">View All Teacher Books</option>
                  {teacherList.map((teacher) => (
                    <option key={teacher.id} value={teacher.id}>
                      {teacher.name}
                    </option>
                  ))}
                </select>
            }
                <Input
                  type='text'
                  name='searchInvoice'
                  placeholder='Search Book'
                  onInput={(e) => {
                    setBookSearchValue(e.target.value);
                    e.target.value.length === 0 && emptyCall();
                  }}
                />
              </div>
              </Col>
              <Col style={{ paddingLeft: '0px' }} sm={1}>
                <Button
                  style={{ margin: '0px', padding: '6px 10px' }}
                  color='info'
                  onClick={bookSearch}
                >
                  <SearchIcon />
                </Button>
              </Col>
            </Row>
            {!search && (
              <Row
                style={{
                  justifyContent: 'flex-end',
                  width: '50%',
                  paddingBottom: '8px',
                }}
              >
                <Col
                  style={{ display: 'flex', justifyContent: 'flex-end' }}
                  sm={6}
                >
                  <p
                    style={{
                      position: 'relative',
                      top: '8px',
                      marginRight: '15px',
                    }}
                  >
                    {startIndex <= 1 ? 1 : startIndex} - {endIndex}
                  </p>
                  <div
                    style={{
                      position: 'relative',
                      top: '-5px',
                      marginRight: '5px',
                    }}
                  >
                    
                    <>
                      {isPrevBook && <IconButton
                        style={{ outline: 'none' }}
                        onClick={() => getBookData('prev')}
                        disabled={!isPrevBook} // Disable if no previous data
                      >
                        <KeyboardArrowLeftSharpIcon style={{ color: 'white' }} />
                      </IconButton>}

                      {isNextBook &&
                      <IconButton
                        style={{ outline: 'none' }}
                        onClick={() => getBookData('next')}
                        disabled={!isNextBook} // Disable if no more data
                      >
                        <KeyboardArrowRightSharpIcon style={{ color: 'white' }} />
                      </IconButton>}
                    </>
                  </div>

                  <select
                    className='form-control'
                    style={{
                      maxWidth: 67,
                      marginRight: 10,
                      position: 'relative',
                      top: 3,
                    }}
                    type='select'
                    value={limit}
                    onChange={(e) => setLimit(parseInt(e.target.value))}
                    // required
                  >
                    <option value='10'>10</option>
                    <option value='50'>50</option>
                    <option value='100'>100</option>
                  </select>
                </Col>
                {console.log(selected,selectedArr,"checkingData")}
                { selectedArr.length > 0 ? (
                  <Col style={{ paddingRight: '0px' }} sm={1}>
                    <Button
                      style={{ margin: '0px', padding: '6px 10px' }}
                      color='danger'
                      onClick={() => setIsAllDeleteModalVisible(true)}
                    >
                      <Delete />
                    </Button>
                  </Col>
                ) : null}
              </Row>
            )}
          </>
        )}

        <Modal isOpen={deleteModalVisible} style={{ width: 230 }}>
          <ModalBody>
            <Book_Delete_Step1
              deletedBook={editBook !== undefined && editBook}
              // setVisible={setVisible}
              setBoookData={setBoookData}
              notify={notify}
              setEndIndex={setEndIndex}
              onClick={() => {
                setDeleteModalVisible(false);
              }}
            />
          </ModalBody>
        </Modal>
        <Modal
          isOpen={isAllDeleteModalVisible}
          color='primary'
          style={{
            display: 'flex',
            flex: 1,
            top: -40,
            width: 350,
            backgroundColor: '#132639',
            objectFit: 'fill',
          }}
        >
          <ModalBody size='sm' style={{ textAlign: 'center' }}>
            <SelectedBatchDelete
              setIsAllDeleteModalVisible={setIsAllDeleteModalVisible}
              deleteSelected={deleteSelected}
            />
          </ModalBody>
        </Modal>

        <Row style={{ margin: 0, width: '100%' }}>
          {!loading && bookData?.length == 0 && (
            <Col
              sm={3}
              style={{
                paddingBottom: '25px',
                minWidth: '100%',
                color: 'white',
              }}
            >
              <div style={{ textAlign: 'center', marginRight: 185 }}>
                No Data Found
              </div>
            </Col>
          )}
          {bookData !== undefined &&
            editVisible === false &&
            bookData.map((book) => (
              <Col
                sm={3}
                style={{
                  paddingBottom: '25px',
                  minWidth: '210px',
                  maxWidth: '250px',
                }}
              >
                <div
                  style={{
                    overflow: 'hidden',
                    margin: 0,
                    border: '1px solid #2184f8',
                    borderRadius: 5,
                  }}
                >
                  <input
                    type='checkbox'
                    style={{ position: 'relative', top: 10, left: 10 }}
                    checked={book.select}
                    onChange={(e) => {
                      let checked = e.target.checked;
                      console.log("condition Chek",checked);
                      setBoookData(
                        bookData.map((data) => {
                          if (book.itemID === data.itemID) {
                            data.select = checked;
                            if (checked) {
                              console.log("obchecking", bookData.length, selectedArr.length);
                              let selectedArrData = [...selectedArr, { id: book.itemID }]
                              setSelectedArr(selectedArrData);
                              if (bookData.length == selectedArrData.length){
                                setAllChecked(true)
                              }
                            } else {
                              console.log("idUnChecking", book.itemID,selectedArr);
                              setSelectedArr((prev) =>
                                prev.filter(
                                  (dataId) => dataId.id !== book.itemID
                                )
                              );
                            }
                          }
                          if (e.target.checked == false) {
                            setAllChecked(false);
                          }
                          return data;
                        })
                      );
                    }}
                  />
                  {book.bookcover ? (
                    <img
                      src={book.bookcover}
                      alt='bookimage'
                      style={{
                        width: '100%',
                        height: '200px',
                        objectFit: 'contain',
                        borderRadius: 0,
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        setEditVisible(true);
                        setDeleteModalVisible(false);
                        setEditBook(book);
                        setVisible(true);
                      }}
                    />
                  ) : (
                    <img
                      src={require('../assets/img/book.png')}
                      alt='....'
                      style={{
                        width: '100%',
                        height: '200px',
                        objectFit: 'contain',
                        borderRadius: 0,
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        setEditVisible(true);
                        setDeleteModalVisible(false);
                        setEditBook(book);
                        setVisible(true);
                      }}
                    />
                  )}

                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      height: 40,
                      padding: 3,
                      justifyContent: 'space-around',
                    }}
                  >
                    <div style={{ width: 120, height: 40, paddingLeft: 3,marginTop:'2px' }}>
                      <div
                        style={{
                          height: 20,
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        {' '}
                        <p style={{ fontSize: 10, maxLines: 1 }}>
                          {book.title.length > 18 ? `${book.title.slice(0,18)}...`:book.title}
                        </p>
                      </div>
                      <div
                        style={{
                          height: 20,
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        {' '}
                        <p style={{ fontSize: 10 }}>{book.author}</p>
                      </div>
                    </div>

                    <div
                      style={{
                        minWidth: '20%',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: 40,
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          height: 20,
                        }}
                      >
                        <Edit
                          style={{
                            fontSize: 18,
                            cursor: 'pointer',
                            color: '#247cf7',
                          }}
                          onClick={() => {
                            setEditVisible(true);
                            //  setDeleteVisible(false)
                            setDeleteModalVisible(false);
                            setEditBook(book);
                            setVisible(true);
                          }}
                        />

                        <Delete
                          style={{
                            color: '#ff4d4d',
                            fontSize: 18,
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            console.log("deleteHandler 1");
                            setEditVisible(false);
                            // setDeleteVisible(true)
                            setDeleteModalVisible(true);
                            setEditBook(book);
                            // setVisible(true)
                          }}
                        />
                      </div>

                      <p
                        style={{
                          fontSize: 11,
                          textAlign: 'center',
                          height: 20,
                        }}
                      >
                        <i
                          className='fas fa-rupee-sign'
                          style={{ fontSize: 9, marginRight: 3 }}
                        ></i>
                        {book.price}
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          {/* </div> */}
        </Row>
        {/* </div> */}
      </Row>
    </Col>
  );
}
export default Book_List;
